<template>
  <v-dialog v-model="dialog" scrollable width="850">
    <v-card>
      <v-toolbar color="primary" dense class="elevation-0" dark>
        <v-toolbar-title>Tạo Đề Xuất Mua Sắm Thiết Bị</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-4">
        <ProposalForm ref="proposalForm" />
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn outlined @click="cancel">HUỶ</v-btn>
        <v-spacer />
        <v-btn color="primary" @click="save">GỬI ĐỀ XUẤT</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ProposalForm from '@/modules/facility/proposal/ProposalForm.vue'
import { mapActions } from 'vuex'

export default {
  name: 'ProposalNewDialog',
  components: { ProposalForm },
  props: {
    state: Boolean
  },
  data() {
    return {
      dialog: false
    }
  },
  watch: {
    state(val) {
      if (val) this.dialog = true
    }
  },
  methods: {
    ...mapActions('FacilityProposals', ['createProposal']),
    cancel() {
      this.dialog = false
      if (this.$refs.proposalForm) {
        this.$refs.proposalForm.resetValidation()
      }
    },
    async save() {
      if (!this.$refs.proposalForm.validate()) return

      this.$loading.active = true
      try {
        const payload = this.$refs.proposalForm.getData()
        await this.createProposal(payload)
        this.dialog = false
        this.$emit('updated')
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
